import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {editIndustry, getIndustryById, createIndustry} from './../../../Store/Actions/industry';
import IndustryAdminComponent from '../../../Components/AdminComponents/Industry';

const IndustryContainer = () => {
  const dispatch = useDispatch();
  const [editData, setEditData] = useState();
  const {allIndustries} = useSelector(({industry}) => industry);

  useEffect(() => {
    if (
      allIndustries &&
      allIndustries?.data?.industry &&
      allIndustries?.data?.industry[0]
    ) {
      setEditData(allIndustries?.data?.industry[0]);
    }
  }, [allIndustries]);

  useEffect(() => {
    fetchIndustryById();
  }, []);

  const updateIndustry = (Data, id) => {
    dispatch(editIndustry(Data, id));
  };

  const createNewIndustry = (Data) => {
    dispatch(createIndustry(Data));
  };

  const fetchIndustryById = () => {
    dispatch(getIndustryById());
  };
  return (
    <IndustryAdminComponent
      updateIndustry={(Data, id) => {
        updateIndustry(Data, id);
      }}
      createIndustry={(Data) => {
        createNewIndustry(Data);
      }}
      EditData={editData}
    />
  );
};

export default IndustryContainer;
